module.exports = __webpack_public_path__ + "static/img/13.bb239f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/zh/13.png
// module id = n82n
// module chunks = 0